// biome-ignore lint/suspicious/noExplicitAny: Using any as a default for functions unless one is passed as a generic
type createContextT = <k extends (...args: any) => any>() => {
	inject: (childFunction: k) => (...args: Parameters<k>) => ReturnType<k>;
	provide: (parentFunction, childFunction: k) => typeof parentFunction;
};

const createContext: createContextT = () => {
	const contextStack: Array<(...args: any) => any> = [];

	return {
		inject: (originalFunction) => {
			return (...args) => {
				const proxy = contextStack[contextStack.length - 1];
				if (proxy) return proxy(...args);
				return originalFunction(...args);
			};
		},
		provide: (parentFunction, ctx) => {
			return (...args) => {
				contextStack.unshift(ctx);
				const result = parentFunction(...args);
				contextStack.shift();
				return result;
			};
		},
	};
};

export default createContext;
